interface Step {
  number: number;
  label: string;
}

interface StepNavigationProps {
  steps: Step[];
  currentStep: number;
  highestStepReached: number;
  onStepClick: (stepNumber: number) => void;
}

export const StepNavigation: React.FC<StepNavigationProps> = ({
  steps,
  currentStep,
  highestStepReached,
  onStepClick,
}) => {
  const getStepCircleClasses = (stepNumber: number) => {
    const isActive = currentStep === stepNumber;
    const isCompleted = currentStep > stepNumber;
    const isReachable = stepNumber <= highestStepReached;

    return `
      absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 
      w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold
      transition-all duration-300
      ${
        isActive
          ? "bg-primary-600 text-white ring-4 ring-primary-200 dark:ring-primary-800"
          : isCompleted
          ? "bg-primary-600 text-white"
          : "bg-gray-200 dark:bg-primary-700 text-gray-400 dark:text-gray-300"
      }
      ${isReachable ? "cursor-pointer hover:bg-primary-700 hover:text-white" : "cursor-not-allowed"}
    `;
  };

  const getLineClasses = (stepNumber: number) => {
    return `absolute top-1/2 left-1/2 h-[2px] w-28 ml-10 -translate-y-1/2 transition-all duration-300 ${
      currentStep > stepNumber ? "bg-primary-600" : "bg-gray-300 dark:bg-primary-700"
    }`;
  };

  const getStepTextClasses = (stepNumber: number) => {
    const isActive = currentStep === stepNumber;
    const isReachable = stepNumber <= highestStepReached;

    return `mt-2 text-sm font-semibold text-center transition-colors duration-300 ${
      isActive ? "text-primary-700 dark:text-primary-400" : isReachable ? "text-primary-600 dark:text-primary-300" : "text-gray-400 dark:text-gray-500"
    }`;
  };

  return (
    <div className="flex items-center justify-center mb-8 space-x-8">
      {steps.map((step, index) => (
        <div key={step.number} className="flex flex-col items-center">
          <div className="relative w-40 h-8">
            <div className={getStepCircleClasses(step.number)} onClick={() => step.number <= highestStepReached && onStepClick(step.number)}>
              {step.number}
            </div>
            {index < steps.length - 1 && <div className={getLineClasses(step.number)} />}
          </div>
          <p className={getStepTextClasses(step.number)}>{step.label}</p>
        </div>
      ))}
    </div>
  );
};
